import { TableColumnModel } from '../../../../../Common/Forms/models/table-column.model';
import { templateNameColumnConfig } from './template-name-column.config';
import { templateTypeColumnConfig } from './template-type-column.config';

export const templateColumnsConfig: TableColumnModel[] = [
    templateNameColumnConfig,
    templateTypeColumnConfig
];
